// Find a Distributor: client-side search over the server-rendered, country-grouped list.
// Progressive enhancement — without JS every distributor still shows. Filters cards by a
// prebuilt data-search haystack (name / country / email / website / phone), hides country
// groups with no visible cards, and shows an empty state when nothing matches.

const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

class IntuitionDistributorDirectory extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;
    this.searchEl = this.querySelector('[data-dl-search]');
    this.groups = Array.from(this.querySelectorAll('[data-dl-group]'));
    this.cards = Array.from(this.querySelectorAll('.dl-card'));
    this.countEl = this.querySelector('[data-dl-count]');
    this.emptyEl = this.querySelector('[data-dl-empty]');
    this.resetEl = this.querySelector('[data-dl-reset]');
    this.total = this.cards.length;

    if (this.searchEl) this.searchEl.addEventListener('input', debounce(() => this.apply(), 120));
    if (this.resetEl) this.resetEl.addEventListener('click', () => {
      if (this.searchEl) this.searchEl.value = '';
      this.apply();
      if (this.searchEl) this.searchEl.focus();
    });
  }

  apply() {
    const q = (this.searchEl ? this.searchEl.value : '').trim().toLowerCase();
    let visible = 0;
    for (const card of this.cards) {
      const match = !q || (card.dataset.search || '').includes(q);
      card.hidden = !match;
      if (match) visible++;
    }
    for (const group of this.groups) {
      group.hidden = !group.querySelector('.dl-card:not([hidden])');
    }
    if (this.countEl) {
      this.countEl.textContent = visible === this.total
        ? `${this.total} distributors`
        : `Showing ${visible} of ${this.total} distributors`;
    }
    if (this.emptyEl) this.emptyEl.hidden = visible !== 0;
  }
}

if (!customElements.get('intuition-distributor-directory')) {
  customElements.define('intuition-distributor-directory', IntuitionDistributorDirectory);
}
